module.exports = __webpack_public_path__ + "static/img/EU.c118fa72.svg";